import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Paths } from "../../router/Paths";
import {
  emailValidate,
  passwordValidate,
  phoneNumberValidate,
} from "../../utils/validation";
import { useUser } from "../../hooks/useUser";
import PhoneNumberInput from "../../components/common/PhoneNumberInput";

function SignUpSection() {
  const navigate = useNavigate();
  const { register, authlogin } = useUser();
  const [email, setEmail] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [passwordConfirm, setPasswordConfirm] = useState<string>("");
  const [firstName, setFirstName] = useState<string>("");
  const [lastName, setLastName] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [firstNameError, setFirstNameError] = useState<string>("");
  const [lastNameError, setLastNameError] = useState<string>("");
  const [emailError, setEmailError] = useState<string>("");
  const [phoneError, setPhoneError] = useState<string>("");
  const [passwordError, setPasswordError] = useState<string>("");
  const [passwordOn, setPasswordOn] = useState<boolean>(false);
  const [passwordOnConfirm, setPasswordOnConfirm] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    setEmailError("");
    setPasswordError("");
    setFirstNameError("");
    setLastNameError("");
    setPhoneError("");
  }, [email, password, firstName, lastName, passwordConfirm, phone]);

  const handleLogin = () => {
    navigate(Paths.login);
  };

  const handleSignup = async () => {
    const invalidEmail = emailValidate(email);
    const invalidPassword = passwordValidate(password);
    const invalidPhone = phoneNumberValidate(phone);
    if (!firstName) return setFirstNameError("First name is required");
    if (!lastName) return setLastNameError("Last name is required");
    if (invalidEmail) {
      return setEmailError(invalidEmail);
    }
    if (invalidPhone) return setPhoneError(invalidPhone);
    if (invalidPassword) {
      return setPasswordError(invalidPassword);
    }
    if (password !== passwordConfirm)
      return setPasswordError("Passwords do not match");

    await register({
      email,
      firstName,
      lastName,
      password,
      phoneNumber: `+${phone.replace("-", "")}`,
      setLoading,
    });
  };

  const AuthLogin = async () => {
    await authlogin();
  };

  return (
    <div className={ClassName.container}>
      <div className="bg-[#F8F8F8] rounded-2xl w-full max-w-[540px] py-6 px-3 lg:px-6 flex flex-col mx-2 my-10">
        <span className="text-3xl lg:text-4xl font-bold mb-4">
          Enter your signup details
        </span>
        <span className={ClassName.label}>First name</span>
        <input
          type="text"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          className={ClassName.input}
        />
        {firstNameError && (
          <span className={ClassName.error}>{firstNameError}</span>
        )}
        <span className={ClassName.label}>Last name</span>
        <input
          type="text"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          className={ClassName.input}
        />
        {lastNameError && (
          <span className={ClassName.error}>{lastNameError}</span>
        )}
        <span className={ClassName.label}>Your email address</span>
        <input
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          className={ClassName.input}
        />
        {emailError && <span className={ClassName.error}>{emailError}</span>}
        <span className={ClassName.label}>Your phone number</span>
        {/* <input
          type="text"
          value={phone}
          onChange={(e) => {
            const inputValue = e.target.value;
            if (/^[0-9]*$/.test(inputValue)) {
              setPhone(inputValue);
            }
          }}
          className={ClassName.input}
          maxLength={11}
        /> */}
        <PhoneNumberInput value={phone} onChange={(value) => setPhone(value)} />
        {phoneError && <span className={ClassName.error}>{phoneError}</span>}
        <span className={ClassName.label}>Your password</span>
        <div className={ClassName.input}>
          <input
            type={passwordOn ? "text" : "password"}
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="bg-transparent flex flex-1"
          />
          <img
            src={passwordOn ? "/IconEyeOn.svg" : "/IconEyeOff.svg"}
            alt=""
            className="w-5 h-5 object-contain cursor-pointer"
            onClick={() => setPasswordOn(!passwordOn)}
          />
        </div>
        {passwordError && (
          <span className={ClassName.error}>{passwordError}</span>
        )}
        <span className={ClassName.label}>Confirm password</span>
        <div className={ClassName.input}>
          <input
            type={passwordOnConfirm ? "text" : "password"}
            value={passwordConfirm}
            onChange={(e) => setPasswordConfirm(e.target.value)}
            className="bg-transparent flex flex-1"
          />
          <img
            src={passwordOnConfirm ? "/IconEyeOn.svg" : "/IconEyeOff.svg"}
            alt=""
            className="w-5 h-5 object-contain cursor-pointer"
            onClick={() => setPasswordOnConfirm(!passwordOnConfirm)}
          />
        </div>
        {passwordError && (
          <span className={ClassName.error}>{passwordError}</span>
        )}
        <button
          onClick={handleSignup}
          className="h-12 w-full rounded-lg bg-primary text-white font-bold text-sm lg:text-base mt-4"
        >
          {loading ? "Please wait ... " : "Signup"}
        </button>
        <div className="w-full flex flex-col items-center">
          <span
            className={`${ClassName.label} cursor-pointer mt-0 text-[#B5B5B5]`}
          >
            Already have an account?
            <span className="text-primary" onClick={handleLogin}>
              {" "}
              Login
            </span>
          </span>
          <div className="relative flex items-center my-6">
            <div className="w-full border-t border-gray-300"></div>
            <span className="px-3 text-gray-500 text-sm">or</span>
            <div className="w-full border-t border-gray-300"></div>
          </div>

          {/* Google Sign-in Button */}
          <button
            onClick={AuthLogin}
            className="flex items-center justify-center border border-gray-300 rounded-lg w-full py-2 text-gray-700 font-medium hover:bg-gray-100"
          >
            <img
              src="/google-image.jpeg"
              alt="Google icon"
              className="w-5 h-5 mr-2"
            />
            Sign up with Google
          </button>
        </div>
      </div>
    </div>
  );
}

export default SignUpSection;

const ClassName = {
  container: "w-full min-h-screen flex items-center justify-center my-10",
  input:
    "border rounded-lg flex flex-1 px-4 py-3 bg-transparent border-[#DBDBDB]",
  error: "text-red-600 text-sm mt-2 mb-2",
  label: "text-[#818083] text-sm lg:text-base font-bold mb-1 mt-4",
};
